import { createAxiosInstance } from '../utils/axiosConfig';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8083/api';

// Create axios instance with default config and interceptors
const bannerAPI = createAxiosInstance({
  baseURL: `${API_BASE_URL}/banner-images`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Banner service functions
export const bannerService = {
  // Get current active banner
  getCurrentBanner: async () => {
    try {
      const response = await bannerAPI.get('/current');
      return response.data;
    } catch (error) {
      console.error('Error fetching current banner:', error);
      throw error;
    }
  },

  // Get all banners (admin only)
  getAllBanners: async () => {
    try {
      const response = await bannerAPI.get('/all');
      return response.data;
    } catch (error) {
      console.error('Error fetching all banners:', error);
      throw error;
    }
  },

  // Get all active banners (public endpoint)
  getActiveBanners: async () => {
    try {
      const response = await bannerAPI.get('/active');
      return response.data;
    } catch (error) {
      console.error('Error fetching active banners:', error);
      throw error;
    }
  },

  // Get default banner
  getDefaultBanner: async () => {
    try {
      const response = await bannerAPI.get('/default');
      return response.data;
    } catch (error) {
      console.error('Error fetching default banner:', error);
      throw error;
    }
  },

  // Create banner with URL
  createBannerWithUrl: async (bannerData) => {
    try {
      const response = await bannerAPI.post('/create-url', bannerData);
      return response.data;
    } catch (error) {
      console.error('Error creating banner with URL:', error);
      throw error;
    }
  },

  // Upload banner image file
  uploadBannerImage: async (formData) => {
    try {
      const response = await bannerAPI.post('/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading banner image:', error);
      throw error;
    }
  },

  // Update banner
  updateBanner: async (id, bannerData) => {
    try {
      const response = await bannerAPI.put(`/${id}`, bannerData);
      return response.data;
    } catch (error) {
      console.error('Error updating banner:', error);
      throw error;
    }
  },

  // Activate banner
  activateBanner: async (id) => {
    try {
      const response = await bannerAPI.put(`/${id}/activate`);
      return response.data;
    } catch (error) {
      console.error('Error activating banner:', error);
      throw error;
    }
  },

  // Deactivate banner
  deactivateBanner: async (id) => {
    try {
      const response = await bannerAPI.put(`/${id}/deactivate`);
      return response.data;
    } catch (error) {
      console.error('Error deactivating banner:', error);
      throw error;
    }
  },

  // Reset to default banner
  resetToDefault: async () => {
    try {
      const response = await bannerAPI.post('/reset-to-default');
      return response.data;
    } catch (error) {
      console.error('Error resetting to default banner:', error);
      throw error;
    }
  },

  // Delete banner
  deleteBanner: async (id) => {
    try {
      const response = await bannerAPI.delete(`/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting banner:', error);
      throw error;
    }
  },

  // Deactivate all banners
  deactivateAllBanners: async () => {
    try {
      const response = await bannerAPI.put('/deactivate-all');
      return response.data;
    } catch (error) {
      console.error('Error deactivating all banners:', error);
      throw error;
    }
  },

  // Activate multiple banners
  activateMultipleBanners: async (bannerIds) => {
    try {
      const response = await bannerAPI.put('/activate-multiple', { bannerIds });
      return response.data;
    } catch (error) {
      console.error('Error activating multiple banners:', error);
      throw error;
    }
  },
};

export default bannerService;